import classNames from "classnames";
import Image from "next/image";
import { StrapiStore } from "~/shared-types";
import { getFormattedImageAttributes } from "~/utils/getImageAttributes";
import { StoreAddress } from "../StoreAddress";
import { StoreDetails } from "../StoreDetails";
import { StoreOpeningHours } from "../StoreOpeningHours";
import { LinkButton } from "~/components/LinkButton";
import { getRoute } from "~/utils/getRoute";
import { StoreFreeDelivery } from "../StoreFreeDelivery";

type StoreInfoProps = {
  store: StrapiStore | null;
  className?: string;
};

function StoreInfo({ store, className }: StoreInfoProps) {
  const storeImage = store?.attributes.storeImage.data;
  return (
    <>
      {storeImage && (
        <div
          className={classNames(
            "flex flex-col xl:flex-row items-start justify-between xl:gap-x-16 2xl:gap-x-36 bg-secondary-100 -mx-5 md:mx-0 px-5 py-14 sm:py-20 sm:px-28 xl:px-16 2xl:px-40 rounded-md",
            className
          )}
        >
          <div className="mb-11 w-full xl:mb-0 xl:order-1 xl:w-1/2 2xl:max-w-xl flex justify-center xl:justify-end xl:items-end">
            <Image
              className="min-w-[80px] max-w-[240px] xl:max-w-[100%] mx-auto sm:ml-0 w-full aspect-square object-cover rounded-xl"
              {...getFormattedImageAttributes(storeImage, "large")}
            />
          </div>
          <div className="flex flex-col gap-8">
            <StoreDetails className="col-span-2" store={store} />
            <div className="grid grid-cols-2 gap-10">
              <StoreAddress
                className="col-span-full sm:col-span-1"
                store={store}
              />
              <StoreOpeningHours
                className="col-span-full sm:col-span-1"
                store={store}
              />

              <StoreFreeDelivery className="col-span-full" store={store} />
            </div>

            <LinkButton
              href={getRoute("/stores/:id", { id: store.id })}
              className="max-w-max mt-7"
            >
              Se butik
            </LinkButton>
          </div>
        </div>
      )}
    </>
  );
}

export { StoreInfo };
